import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const createPlace = async (payload) => {
  const service = getService(ServiceName.CadSearchPlaces);
  const response = await service.create(payload);
  return response?.data || response;
};

export const getPlaceDetails = async (ptsPlaceID) => {
  const service = getService(ServiceName.Places);
  return service.get(ptsPlaceID);
};

export const updatePlaceDetails = async (ptsPlaceID, payload) => {
  const service = getService(ServiceName.CadSearchPlaces);
  const response = await service.patch(ptsPlaceID, { Place: payload });
  return response?.data || response;
};

export const getPlaceContacts = async (ptsPlaceID) => {
  const service = getService(ServiceName.RecordPersonContact);
  const response = await service.find({
    query: {
      ptsParentID: ptsPlaceID,
      PartyType: 'Place',
      IsDeleted: false,
      $sort: { Created: -1 },
    },
  });
  return response?.data || response || [];
};

export const getPlaceEmployees = async (ptsPlaceID) => {
  const service = getService(ServiceName.RecordPersonEmployment);
  const response = await service.find({
    query: {
      ptsPlaceID,
      IsDeleted: false,
      $sort: { Created: -1 },
    },
  });
  const rows = response?.data || response || [];

  return rows.map((row) => {
    const person =
      Array.isArray(row.PersonInfo) && row.PersonInfo.length ? row.PersonInfo[0] : null;
    return {
      ...row,
      FirstName: person?.FirstName || null,
      LastName: person?.LastName || null,
      FullName: person?.FullName || null,
      rowKey: `${row.ptsPersonID}-${row.ptsPlaceID}`,
    };
  });
};

export const savePlaceEmployment = async (payload) => {
  const service = getService(ServiceName.RecordPersonEmployment);
  const { ptsPersonID, ptsPlaceID } = payload;
  const existing = await service.find({ query: { ptsPersonID, ptsPlaceID } });
  const rows = existing?.data || existing || [];

  if (rows.length) {
    return service.update({ ptsPersonID, ptsPlaceID }, { ...payload, IsDeleted: false });
  }

  return service.create(payload);
};

export const deletePlaceEmployment = async (compositeKey) => {
  const service = getService(ServiceName.RecordPersonEmployment);
  return service.remove(null, { query: compositeKey });
};
